window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
//gtag('config', 'UA-60830195-1');

var GoogleAnalytics = {
    pageview: function (title, url) {
        gtag('config', 'UA-60830195-1', {
          'page_title': title,
          'page_path': url
        });
    }
};
